import { SettingsUsersUserFullDto } from '../interfaces';
import { generateMock } from '../../../lib';
import { mockUserFullFields } from './userMockFields';

export const getSettingsUsersMockUser = () => {
    return generateMock<SettingsUsersUserFullDto>(mockUserFullFields);
};
